import {BaseEntity} from '../../common/base-entity';
import {CirfTopicSection} from './topic-section';

export class CirfConfigTopic extends BaseEntity{
    topicLabel: string;
    topicKey: string;
    topicSections: CirfTopicSection[];

    constructor(topic?: CirfConfigTopic) {
        super(topic);
        if (topic) {
            if (topic.topicSections) {
                this.topicSections = topic.topicSections.map(section => new CirfTopicSection(section));
            }
        } else {
            this.topicSections = [];
        }
    }
}
